import { useEffect, useState } from "react";
import axios from "axios";
import { X } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const TYPE_LABELS = { limit: "Limit", stop: "Stop-Loss", take_profit: "Take-Profit" };

export default function PendingOrders({ token }) {
  const [orders, setOrders] = useState([]);

  const load = () =>
    token &&
    axios
      .get(`${API}/terminal/pending`, { headers: { Authorization: `Bearer ${token}` } })
      .then(({ data }) => setOrders(data.orders || []))
      .catch(() => {});

  useEffect(() => {
    load();
    const t = setInterval(load, 20000);
    return () => clearInterval(t);
  }, [token]);

  const cancel = async (id) => {
    await axios.post(`${API}/terminal/cancel`, { order_id: id }, { headers: { Authorization: `Bearer ${token}` } });
    load();
  };

  if (orders.length === 0) return null;

  return (
    <div className="mt-4 border border-gold/25 bg-surface p-6" data-testid="pending-orders">
      <p className="mb-5 text-[10px] uppercase tracking-[0.25em] text-gold/80">Pending orders</p>
      <div className="space-y-2">
        {orders.map((o) => (
          <div key={o.id} className="flex flex-wrap items-center gap-x-5 gap-y-1 border-b border-white/5 pb-2 text-xs">
            <span className={o.side === "buy" ? "text-[#26A69A]" : "text-[#EF5350]"}>{o.side.toUpperCase()}</span>
            <span className="text-white">{o.qty} {o.symbol}</span>
            <span className="font-tabular text-white/50">@ ${Number(o.limit_price).toLocaleString()}</span>
            <span className="text-[10px] uppercase tracking-[0.15em] text-gold/60">{TYPE_LABELS[o.order_type] || o.order_type}</span>
            {o.leverage > 1 && <span className="font-tabular text-[10px] text-white/35">{o.leverage}x</span>}
            <button
              data-testid={`cancel-order-${o.id.slice(-6)}`}
              onClick={() => cancel(o.id)}
              className="ml-auto flex items-center gap-1 text-[10px] uppercase tracking-[0.15em] text-white/40 transition-colors duration-300 hover:text-[#EF5350]"
            >
              <X className="h-3 w-3" /> Cancel
            </button>
          </div>
        ))}
      </div>
    </div>
  );
}
